var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 329.02 49.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#655546;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "base"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.84,25a39.76,39.76,0,0,1,5.6-6.14,64.58,64.58,0,0,1,6.54-5.2A75.16,75.16,0,0,1,235.8,5.76,82.57,82.57,0,0,1,269.12.05a88.22,88.22,0,0,1,32.79,7.53A83.84,83.84,0,0,1,329,26.32c-2.72-.65-5.29-1.46-7.85-2.25-1.31-.34-2.58-.73-3.86-1.1s-2.51-.81-3.81-1.1l-3.79-1.05c-.63-.16-1.24-.37-1.88-.53l-1.89-.46c-1.27-.3-2.51-.64-3.75-1s-2.52-.53-3.75-.84a160.92,160.92,0,0,0-29.79-4,138.29,138.29,0,0,0-29.75,2.24A158.91,158.91,0,0,0,208.84,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,26.51a39.79,39.79,0,0,1,5.87-5.88,65.5,65.5,0,0,1,6.77-4.9A75.61,75.61,0,0,1,27.8,8.51,82.86,82.86,0,0,1,61.35,4.32a87.85,87.85,0,0,1,32.41,9A83.61,83.61,0,0,1,120,33.27c-2.68-.77-5.22-1.7-7.74-2.6-1.29-.41-2.55-.85-3.81-1.27s-2.47-.93-3.75-1.28L101,26.9c-.63-.19-1.23-.43-1.85-.61l-1.88-.55c-1.25-.35-2.47-.75-3.69-1.13s-2.5-.64-3.72-1a160.85,160.85,0,0,0-29.57-5.34,138.16,138.16,0,0,0-29.83.9A159.43,159.43,0,0,0,0,26.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.44,14.35A91.6,91.6,0,0,0,191.19,24a39.65,39.65,0,0,0,3.22,8.84,20.69,20.69,0,0,0,5.77,7,24.88,24.88,0,0,0,8.66,3.95,16.41,16.41,0,0,1-9.93-2,18.11,18.11,0,0,1-7.16-7.58,27.33,27.33,0,0,1-2.86-9.84A29.35,29.35,0,0,1,189.44,14.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136.94,21.85a18.62,18.62,0,0,1,4.24,6.31,21.33,21.33,0,0,1,1.67,7.56,18.31,18.31,0,0,1,0,2l-.24,2c-.12.64-.3,1.28-.47,1.91-.09.31-.16.63-.28.94l-.38.9a16.19,16.19,0,0,1-4.51,6.16,42.48,42.48,0,0,0,2.26-6.88l.21-.85c.06-.28.08-.57.12-.86.06-.58.19-1.14.23-1.71a30.4,30.4,0,0,0,.09-3.44,37.61,37.61,0,0,0-.9-6.93A72.11,72.11,0,0,0,136.94,21.85Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset5);
export default __webpack_public_path__ + "static/media/Asset 5.a5b6e7b2.svg";
export { ForwardRef as ReactComponent };